import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, NumberRangeValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class NumberRangeHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const arr = [];
    const nrv = (qc.value as NumberRangeValue);
    (nrv.startValue != null) && arr.push({
      'FilterField': qc.fieldCode,
      'Compare': CompareType.GreaterOrEqual, // GreaterOrEqual
      'Value': nrv.startValue,
      'Relation': RelationType.And, // and
      'Expresstype': ValueType.Value
    });
    (nrv.endValue != null) && arr.push({
      'FilterField': qc.fieldCode,
      'Compare': CompareType.LessOrEqual, // LessOrEqual
      'Value': nrv.endValue,
      'Relation': RelationType.And, // and
      'Expresstype': ValueType.Value
    });

    return arr;
  }
}
